import React from 'react';
import type {BoxProps, HeadingProps} from '@tempo/core';
import {Box, Flex, Heading, HStack, Text, VStack} from '@tempo/core';

type SectionRowProps = {
	title?: string;
	subtitle?: React.ReactNode;
	rightElements?: React.ReactNode;
	titleProps?: HeadingProps;
	hideTopBorder?: boolean;
} & BoxProps;

const SectionRow = ({
	title,
	subtitle,
	rightElements,
	titleProps,
	hideTopBorder,
	...props
}: SectionRowProps) => {
	return (
		<Flex
			justifyContent="space-between"
			pt={{base: 'spacing.l', md: 'spacing.xl'}}
			pb={{base: 'spacing.s', md: 'spacing.m'}}
			px={{base: 'spacing.l', md: 'spacing.xl'}}
			alignItems="center"
			borderTopStyle={'solid'}
			borderBottomStyle={'solid'}
			borderBottomWidth={'1px'}
			borderTopWidth={hideTopBorder ? 0 : '1px'}
			borderColor="divider.neutral.primary.default"
			bg="background.neutral.secondary.default"
			{...props}
		>
			<Box>
				<VStack alignItems="initial" spacing="spacing.xs" {...props}>
					{title && (
						<Heading as="h1" variant={'heading.xs'} {...titleProps}>
							{title}
						</Heading>
					)}
					{subtitle && (
						<Text
							color="text.neutral.secondary.default"
							variant="caption.strong"
						>
							{subtitle}
						</Text>
					)}
				</VStack>
			</Box>
			<Box>
				<HStack spacing="spacing.s">{rightElements}</HStack>
			</Box>
		</Flex>
	);
};

export default SectionRow;
